/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/web.dom-collections.for-each.js";

var EventBus = /*#__PURE__*/function () {
  function EventBus(vue) {
    _classCallCheck(this, EventBus);

    if (!this.handles) {
      Object.defineProperty(this, 'handles', {
        value: {},
        enumerable: false
      });
    }

    this.Vue = vue; // _uid和EventName的映射

    this.eventMapUid = {};
  }

  _createClass(EventBus, [{
    key: "setEventMapUid",
    value: function setEventMapUid(uid, eventName) {
      if (!this.eventMapUid[uid]) this.eventMapUid[uid] = [];
      this.eventMapUid[uid].push(eventName); // 把每个_uid订阅的事件名字push到各自uid所属的数组里
    }
  }, {
    key: "$on",
    value: function $on(eventName, callback, vm) {
      // vm是在组件内部使用时组件当前的this用于取_uid
      if (!this.handles[eventName]) this.handles[eventName] = [];
      this.handles[eventName].push(callback);
      if (vm instanceof this.Vue) this.setEventMapUid(vm._uid, eventName);
    }
  }, {
    key: "$emit",
    value: function $emit() {
      var args = Array.prototype.slice.call(arguments);
      var eventName = args[0];
      var params = args.slice(1);

      if (this.handles[eventName]) {
        var len = this.handles[eventName].length;

        for (var i = 0; i < len; i++) {
          var _this$handles$eventNa;

          (_this$handles$eventNa = this.handles[eventName])[i].apply(_this$handles$eventNa, _toConsumableArray(params));
        }
      }
    }
  }, {
    key: "$offVmEvent",
    value: function $offVmEvent(uid) {
      var _this = this;

      var currentEvents = this.eventMapUid[uid] || [];
      currentEvents.forEach(function (event) {
        _this.$off(event);
      });
    }
  }, {
    key: "$off",
    value: function $off(eventName) {
      delete this.handles[eventName];
    }
  }, {
    key: "$destory",
    value: function $destory() {
      this.eventMapUid = {};
      this.handles = {};
    }
  }]);

  return EventBus;
}(); // 写成Vue插件形式，直接引入然后Vue.use($EventBus)进行使用


var $EventBus = {};

$EventBus.install = function (Vue, option) {
  Vue.prototype.$eventBus = new EventBus(Vue);
  Vue.mixin({
    beforeDestroy: function beforeDestroy() {
      // 拦截beforeDestroy钩子自动销毁自身所有订阅的事件
      this.$eventBus.$offVmEvent(this._uid);
    }
  });
  return Vue.prototype.$eventBus;
};

export default $EventBus;